<template>
    <div class="hstack gap-2 align-self-end">
        <label class="b-table-header-info" v-if="totalLabelValue != ''">
            {{totalLabelValue}}
        </label>
        <select class="form-select b-table-header-pagesize py-1 border border-dark" aria-label="Select Page Size" v-model.number="value.itemsPerPage" @change="setItemsPerPage" placeholder="Select an agency">
            <option v-for="option in itemsPerPageOptions"
                    :value="option.value">
                {{ option.text }}
            </option>
        </select>
        <button type="button" :class="'btn btn-sm ' + (!isPreviousDisabled?'border border-dark':'')"
                    @click.prevent="first()"
                    :disabled="isPreviousDisabled"
                    data-bs-toggle="tooltip"
                    data-bs-title="First Page">
                <i class="bi bi-chevron-double-left"></i>
            </button>
            <button type="button" :class="'btn btn-sm ' + (!isPreviousDisabled?'border border-dark':'')"
                    @click.prevent="go(-1)"
                    :disabled="isPreviousDisabled"
                    data-bs-toggle="tooltip"
                    data-bs-title="Previous Page">
                <i class="bi bi-chevron-left"></i>
            </button>
            <button type="button" :class="'btn btn-sm ' + (!isNextDisabled?'border border-dark':'')"
                    @click.prevent="go(+1)"
                    :disabled="isNextDisabled"
                    data-bs-toggle="tooltip"
                    data-bs-title="Next Page">
                <i class="bi bi-chevron-right"></i>
            </button>
        
    </div>
</template>
<script setup lang="ts">
import { computed, ref, defineProps, watch, onMounted } from 'vue';
import { BTableOptions, BSelectOptionsNumber } from "@/components/BTable/BTable.types";
import { BFilter } from '../BFilterEditor/BFilterEditor.types';

const emits = defineEmits(['optionChange']);

const props = withDefaults(defineProps<{
    value: BTableOptions,
    headerSlotClass?: string,
    filters?:BFilter[],
    isNextDisabled?:boolean,
    currentItemCount: number
    }>(), {
        headerSlotClass: '',
        filters: [],
        isNextDisabled: false
    });
    
    var options = ref(props.value as BTableOptions);

    const itemsPerPageOptions = [
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
        ] as BSelectOptionsNumber[];    


    var isPreviousDisabled = computed(():boolean => {
        return options.value.page == 1;
    });

    var isNextDisabled = computed(():boolean => {
        return props.isNextDisabled || props.currentItemCount <= options.value.itemsPerPage;
    });

    var totalLabelValue = ref('');
    
    function setTotalLabel() {
        /*
        CI-2598 - Current Requirements
        If the filters contain one of the following then show the total item count otherwise hide it. 
            - All outstanding errors and warnings
            - All outstanding errors
            - All outstanding warnings
            - All outstanding errors and warnings for a single ORI
            - All outstanding errors for a single ORI
            - All outstanding warnings for a single ORI
        */
       
        let start = props.currentItemCount == 0 ? 0 : (options.value.page - 1) * options.value.itemsPerPage + 1;

        let itemCount = props.currentItemCount;
        
        //adjusting itemCount to account for the +1 item we include to determine if the next button should be enabled
        if(props.currentItemCount == options.value.itemsPerPage + 1){
            itemCount = itemCount - 1;
        }

        let end = start + itemCount - 1;
        
        if(end < 0){
            end = 0;
        }

        let label = `${start} - ${end}`;

        let hasOutstandingFilter = false;

        props.filters.forEach((filter:BFilter)=> {
            if(filter.property === 'status' && filter.value === 'Unresolved'){
                hasOutstandingFilter = true;
            }

            //insert other checks here
        });
        //if conditions are met then set the item total
        if(hasOutstandingFilter) {
            label += ` of ${options.value.totalItemCount}`;
        }
        else if(props.currentItemCount <= options.value.itemsPerPage) {
            label += ` of ${end}`
        }
        else {
            label += ` of many`;
        }
        
        totalLabelValue.value = label;
    };

    function goToPage(pageNumber: number) {       
        options.value.page = pageNumber;
        emits("optionChange", options.value);
    }
    
    function go(deltaPage: number) {
        goToPage(Math.max(1, options.value.page + deltaPage));
    }
            
    function setItemsPerPage(e:any) { 
        options.value.itemsPerPage = options.value.itemsPerPage;
        options.value.page = 1;
        emits("optionChange", options.value);
    }

    function first() {
        goToPage(1);
    }
    
    watch(
        () => props.value,
        (newOptions) => {
            setTotalLabel();
        },
        {
            deep:true
        }
    );
    
    watch(
        () => props.currentItemCount,
        () => {
            setTotalLabel();
        }
    );

    onMounted(() => {
        setTotalLabel();    
    });
</script>